var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2896 17.127C13.8368 17.127 17.9648 10.8742 17.9648 5.45182C17.9648 5.27422 17.9648 5.09742 17.9528 4.92142C18.7559 4.34055 19.4491 3.62132 20 2.79742C19.2511 3.12926 18.4567 3.34688 17.6432 3.44302C18.4998 2.9302 19.1409 2.12363 19.4472 1.17342C18.6417 1.65138 17.7605 1.98823 16.8416 2.16942C16.2229 1.51156 15.4047 1.07595 14.5135 0.929987C13.6223 0.784023 12.7079 0.935846 11.9116 1.36196C11.1154 1.78808 10.4819 2.46473 10.109 3.28721C9.73605 4.10969 9.64462 5.03214 9.8488 5.91182C8.2174 5.83003 6.62144 5.40608 5.16451 4.66749C3.70759 3.9289 2.42227 2.89217 1.392 1.62462C0.867274 2.52795 0.70656 3.59731 0.942583 4.61497C1.17861 5.63263 1.79362 6.52208 2.6624 7.10222C2.00939 7.08286 1.37062 6.90671 0.8 6.58862C0.8 6.60542 0.8 6.62302 0.8 6.64062C0.800259 7.58799 1.12821 8.50611 1.72823 9.23925C2.32824 9.9724 3.16338 10.4754 4.092 10.663C3.4879 10.8278 2.85406 10.8519 2.2392 10.7334C2.50141 11.5488 3.01189 12.2617 3.69926 12.7727C4.38662 13.2836 5.21649 13.5669 6.0728 13.583C4.61979 14.725 2.82485 15.3449 0.9768 15.343C0.650323 15.3424 0.324163 15.3226 0 15.2838C1.87651 16.488 4.05993 17.1268 6.2896 17.1238V17.127Z",
    fill: "#B3B3C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.fb8d76e767d99951be33b096ea82da49.svg";
export { ForwardRef as ReactComponent };